import { Component, Emit, Vue, Watch } from 'vue-property-decorator';
import { LoginUser } from "@/types/Component";

@Component
export default class Record extends Vue {
    private currentMenu = 'disposal'
    private returnTo: string | (string | null)[] = ''
    private recordDate: string | null = null
    private isLoading = false
    private isEditable = true
    private isDisposalModalOpen = false

    get isAdmin(): boolean {
        return this.loginUser.role.find((r: string) => {
            return r === 'ADMIN'
        }) !== undefined;
    }

    get loginUser(): LoginUser {
        return this.$store.getters.loginUser;
    }

    get refs(): any {
        return this.$refs;
    }

    get hasProducerPlanOnly():LoginUser {
        return this.$store.getters.loginUser.hasProducerPlanOnly
    }

    @Watch('$route')
    onRouteChange() {
        
        this.currentMenuInfo()
        this.recordDate = this.$route.query.date ? this.$route.query.date as string : null
        this.returnTo = this.$route.query.return_to
        this.isEditable = true
    }

    created() {
        this.currentMenuInfo()
        this.recordDate = this.$route.query.date ? this.$route.query.date as string : null
        this.returnTo = this.$route.query.return_to
    }

    currentMenuInfo() {
        if(this.$store.getters.loginUser.hasProducerPlanOnly === true){
            alert("農薬ナビに参加していない為、利用できません");
            return;
        }
        const path = this.$route.path
        const pathList = path.split('/')
        this.currentMenu = pathList[2]
    }

    enableDelete() {
        const params = this.$route.params
        return params.work_record_id || params.harvest_record_id || params.shipping_record_id
    }

    enableCopy() {
        return this.currentMenu == 'work'
    }

    enableCancel() {
        return this.currentMenu == 'disposal'
    }

    back() {
        const param = this.recordDate ? `?date=${this.recordDate}` : ''
        this.$router.push(`/${this.returnTo}${param}`, () => { return })
    }
    async deleteRecord() {
        this.isLoading = true
        await this.refs.record.deleteRecord()
        this.isLoading = false
    }
    async saveAndCopyRecord() {
        this.isLoading = true
        await this.refs.record.saveAndCopyRecord()
        this.isLoading = false
        this.$store.dispatch('doUpdateIsInputChanged', false);
    }
    async saveRecord() {
        this.isLoading = true
        await this.refs.record.saveRecord()
        this.isLoading = false
        this.$store.dispatch('doUpdateIsInputChanged', false);
    }
    async recordCancel(){
        this.isLoading = true
        await this.refs.record.cancelRecord()
        this.isLoading = false
    }
}